import {
  Component
}
from '@angular/core';

import {
  CommonModule
}
from '@angular/common';

import {
  FormsModule
}
from '@angular/forms';

import {
  HttpClient
}
from '@angular/common/http';

import {
  Router
}
from '@angular/router';

import {
  ChangeDetectorRef
}
from '@angular/core';

import { AdminNavbar }
from '../admin-navbar/admin-navbar';

@Component({
  selector:
    'app-categories-create',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    AdminNavbar
  ],

  templateUrl:
    './categories-create.html',

  styleUrls: [
    './categories-create.scss'
  ]
})
export class CategoriesCreate
{
  category =
  {
    name: '',
    slug: '',
    image: ''
  };

  imagePreview = '';

  uploading = false;

  saving = false;

  cloudinaryUrl =
    'https://api.cloudinary.com/v1_1/dle6ao4m7/image/upload';

  constructor(
    private http:
      HttpClient,

    private router:
      Router,

    private cdr:
      ChangeDetectorRef
  ) {}

  onNameChange()
  {
    this.category.slug =
      this.category.name

        .toLowerCase()

        .replace(/\s+/g, '-')

        .replace(/č/g, 'c')
        .replace(/ć/g, 'c')
        .replace(/š/g, 's')
        .replace(/ž/g, 'z')
        .replace(/đ/g, 'dj');
  }

  onFileSelected(event: any)
  {
    const file =
      event.target.files[0];

    if (!file)
      return;

    this.uploading = true;

    const formData =
      new FormData();

    formData.append(
      'file',
      file
    );

    formData.append(
      'upload_preset',
      'lazzaro_unsigned'
    );

    this.http.post(
      this.cloudinaryUrl,
      formData
    )

    .subscribe({

      next: (response: any) =>
      {
        this.category.image =
          response.secure_url;

        this.imagePreview =
          response.secure_url;

        this.uploading = false;

        this.cdr.detectChanges();
      },

      error: (err) =>
      {
        console.log(err);

        this.uploading = false;

        this.cdr.detectChanges();
      }
    });
  }

  save()
  {
    if (this.uploading)
      return;

    this.saving = true;

    this.http.post(
      'https://lazzaro-api1.onrender.com/api/categories',
      this.category
    )

    .subscribe({

      next: () =>
      {
        this.router.navigate([
          '/admin/categories'
        ]);
      },

      error: (err) =>
      {
        console.log(err);

        this.saving = false;
      }
    });
  }
}